import { Actions } from 'vuex-smart-module';
import { VideosService } from '../services';
import VideosState from './state';
import VideosMutations from './mutations';
import VideosGetters from './getters';

const videosService = new VideosService();

export default class VideosActions extends Actions<
  VideosState,
  VideosGetters,
  VideosMutations,
  VideosActions
> {
  async get_videos() {
    try {
      const { data } = await videosService.get_videos();

      this.mutations.SET_VIDEOS(data.items);
    } catch (error) {
      console.log(error);
    }
  }
}
